import React from 'react';
import { Trans } from 'react-i18next';

import { Text } from '../../common/Text';

import { formatDate, parseDate } from './utils';

type ParsedDateProps = {
  parseDateFormat?: Parameters<typeof parseDate>[1];
  dateFormat: Parameters<typeof parseDate>[1];
  date?: string;
};

export function ParsedDate({
  parseDateFormat,
  dateFormat,
  date,
}: ParsedDateProps) {
  const parsed =
    date &&
    formatDate(
      parseDateFormat ? parseDate(date, parseDateFormat) : date,
      dateFormat,
    );
  return (
    <Text>
      <Text>
        {date || (
          <Text className="text-[var(--color-pageTextLight)]" style={{ fontStyle: 'italic' }}>
            <Trans>Empty</Trans>
          </Text>
        )}{' '}
        &rarr;{' '}
      </Text>
      <Text className={parsed ? 'text-[var(--color-noticeTextLight)]' : 'text-destructive'}>
        {parsed || <Trans>Invalid</Trans>}
      </Text>
    </Text>
  );
}
